

import $ = require('jquery');
require('jquery-smooth-scroll');

class Application {

    private cookiePanel:JQuery;
    private scroller:JQuery;
    private formSection:JQuery;

    public constructor()
    {
        $(document).ready(() => {
            this.init();
        });
    }

    private init() {
        this.formSection = $('section.form');
        this.scroller = $('.scroller');
        this.cookiePanel = $('.cookie');
        this.initCookies();
        this.initScroller();
        this.initForm();
    }

    private initForm()
    {
        if (this.formSection.length > 0) {
            this.formSection.on('submit', 'form', (evt:Event) => {
                let $form = $(evt.currentTarget);
                evt.preventDefault();
                console.log('Prevent form submit');
                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: $form.serialize()
                })
                    .fail((jqXHR:JQueryXHR, textStatus:string, errorThrown:any) => {
                        $form.replaceWith(jqXHR.responseText);
                    })
                    .done((data:any, textStatus:string, jqXHR:JQueryXHR) => {
                        window.location.href = data;
                        // console.log(data);
                    })
            });
            this.formSection.on('change, keydown', 'input', (evt:Event) => {
                let $el = $(evt.currentTarget);
                if ($el.hasClass('error')) {
                    $el.removeClass('error');
                }
            });
        }
    }

    private initScroller()
    {
        if (this.scroller.length > 0) {
            this.scroller.on('click', (evt:Event) => {
                let $el = $(evt.currentTarget);
                let scrollTarget = $el.attr('href');
                $.smoothScroll({
                    scrollTarget: scrollTarget,
                    speed: 'auto',
                    autoCoefficient: 2
                });
                evt.preventDefault();
            });
        }
    }

    private initCookies()
    {
        if (this.cookiePanel.length > 0) {
            let hasCookies:string = this.getCookie('cookies');
            if (hasCookies === null) {
                this.cookiePanel.addClass('active');
                this.cookiePanel.on('click', '.cookie-button', (evt:JQueryEventObject) => {
                    evt.preventDefault();
                    this.setCookie('cookies', 'accepted');
                    this.cookiePanel.removeClass('active');
                });
            } else {
                this.cookiePanel.removeClass('active');
            }

        }
    }

    private getCookie(id:string) : string|null
    {
        let cookieValue = document.cookie.match('(^|;) ?' + id + '=([^;]*)(;|$)');
        return cookieValue ? cookieValue[2] : null;
    }

    private setCookie (id:string, value:string)
    {
        let expires:any = new Date();
        expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = id + '=' + value + ';expires=' + expires.toUTCString();
    };
}

export { Application };


// WEBPACK FOOTER //
// /Users/pgaultier/Dev/gan-patrimoine-prospection/node_modules/source-map-loader!./app/Application.ts